import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed, ref, watch } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'ImagePreviewOverlay',
  props: {
    visible: { type: Boolean },
    imageUrl: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const imageRef = ref<HTMLImageElement>()
const width = ref(0); const height = ref(0); const minWidth = ref(0); const maxWidth = ref(800)
const imageStyle = computed(() => (width.value ? { width: `${width.value}px`, height: `${height.value}px` } : undefined))
const fitImage = () => { const image = imageRef.value; if (!image?.naturalWidth || !image.naturalHeight) return; const ratio = image.naturalWidth / image.naturalHeight; const fittedWidth = Math.min(window.innerWidth * .94, window.innerHeight * .88 * ratio); const initialWidth = Math.min(800, fittedWidth); maxWidth.value = fittedWidth; minWidth.value = Math.min(initialWidth, Math.max(120, fittedWidth * .35)); width.value = initialWidth; height.value = initialWidth / ratio }
const handleWheel = (event: WheelEvent) => { const image = imageRef.value; if (!image?.naturalWidth || !image.naturalHeight) return; const nextWidth = Math.min(maxWidth.value, Math.max(minWidth.value, width.value + (event.deltaY < 0 ? 80 : -80))); width.value = nextWidth; height.value = nextWidth / (image.naturalWidth / image.naturalHeight) }
watch(() => [props.visible, props.imageUrl], () => { width.value = 0; height.value = 0 })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.visible && __props.imageUrl)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "preview-overlay",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close'))),
          onWheel: _withModifiers(handleWheel, ["prevent"])
        }, [
          _createElementVNode("div", {
            class: "preview-stage",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("button", {
              class: "preview-close",
              type: "button",
              "aria-label": "关闭图片预览",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, "×"),
            _createElementVNode("img", {
              ref_key: "imageRef",
              ref: imageRef,
              src: __props.imageUrl,
              class: "preview-image",
              style: _normalizeStyle(imageStyle.value),
              alt: "图片预览",
              onLoad: fitImage
            }, null, 44, _hoisted_1)
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}
}

})